import { createAction } from '@ngrx/store';

export const signOut = createAction('[Auth] Sign Out');
